module.exports = __webpack_public_path__ + "img/Header2.e967948d.jpg";